import { ChevronLeftIcon } from '@chakra-ui/icons';
import { Box, Container, Heading, Link, Text } from '@chakra-ui/react';
import { FC } from 'react';
import {
    LoaderFunctionArgs,
    Link as ReactRouterLink,
    useLoaderData,
} from 'react-router-dom';
import { fetchAppointments } from '../../api/repository/appointment';
import { fetchStock } from '../../api/repository/stock';
import { fetchUserMe } from '../../api/repository/user';
import { PagePath } from '../../constants/routes';
import { convertAppointmentFromApi } from '../../helpers/appointment';
import {
    convertStockItemFromApi,
    findAppointment,
    findStock,
} from '../../helpers/stock';
import { convertUserFromApi } from '../../helpers/user';
import { AppointmentInterface } from '../../types/appointment';
import { StockItemInterface } from '../../types/stock';
import { UserInterface } from '../../types/user';
import { AppointmentDetail } from '../appointment/AppointmentDetail';

export const loader = async ({ params }: LoaderFunctionArgs) => {
    const { id: stockNumber } = params;
    const stock = await fetchStock();
    const appointments = await fetchAppointments();
    const user = await fetchUserMe();

    const formattedAppointments = appointments?.map((item) =>
        convertAppointmentFromApi(item)
    );

    const formattedStock = stock?.map((item) => convertStockItemFromApi(item, formattedAppointments));

    const formattedUser = convertUserFromApi(user);

    const currentStock = stockNumber
        ? findStock(formattedStock, stockNumber)
        : null;

    if (!currentStock) {
        throw new Response('Not Found', { status: 404 });
    }

    const existingAppointment =
        findAppointment(formattedAppointments, currentStock.stockNumber) ??
        null;

    return {
        currentStock,
        existingAppointment,
        user: formattedUser,
    };
};

export const AppointmentUpdate: FC = () => {
    const { currentStock, existingAppointment, user } = useLoaderData() as {
        currentStock: StockItemInterface;
        existingAppointment: AppointmentInterface;
        user: UserInterface;
    };

    return (
        <Box px={8} py={8}>
            <Link
                as={ReactRouterLink}
                to={PagePath.StockOverview}
                mb={2}
                display={'inline-block'}
            >
                <ChevronLeftIcon />
                Terug naar overzicht
            </Link>
            <Container maxW={'4xl'} px={0}>
                <Heading color={'secondary'}>Afspraak aanpassen</Heading>
                <Text mb={6}>
                    Pas eenvoudig online uw afspraak voor onderhoud of reparatie
                    van een van uw voertuigen aan.
                </Text>

                <AppointmentDetail
                    currentStock={currentStock}
                    existingAppointment={existingAppointment}
                    userLocations={user.locations}
                />
            </Container>
        </Box>
    );
};
